import http from './http';
import { handleResponse } from '@/shared/utils/promise-helpers';

export const getAllPauses = () => {
  return http.get('/pauses').then((res) => res.data);
};

export const getPausesByAgent = (agentId) => {
  return http.get(`/pauses/agent/${agentId}`).then((res) => res.data);
};

export const requestPauseChat = (agentId, pause) =>
  http.post(`/pauses/chat/enter/agent/${agentId}`, pause).then(handleResponse);

export const unpauseChat = (agentId, pause) =>
  http.post(`/pauses/chat/leave/agent/${agentId}`, pause).then(handleResponse);

export const pauseAgentChannelWhatsapp = (agentId, informations) => {
  return http.post(`/pauses/whatsapp/enter/agent/${agentId}`, informations);
};

export const unpauseAgentChannelWhatsapp = (agentId) => {
  return http.post(`/pauses/whatsapp/leave/agent/${agentId}`);
};

export const pauseAgentVoiceChannel = (agentId, informations) => {
  return http
    .post(`/pauses/voice/enter/agent/${agentId}`, informations)
    .then(handleResponse);
};

export const leavePauseVoiceAgentChannel = (agentId) => {
  return http.post(`/pauses/voice/leave/agent/${agentId}`).then(handleResponse);
};

export const pauseAllChannels = (agentId, pause) =>
  http.post(`/pauses/all/enter/agent/${agentId}`, pause).then(handleResponse);

export const unpauseAllChannels = (agentId, channels) =>
  http
    .post(`/pauses/all/leave/agent/${agentId}`, { channels })
    .then(handleResponse);
